import { QuestionItem } from './QuestionItem';
export default QuestionItem;
